<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Ejecutivos Cemento</h1>
  <app-ejecutivos-cemento-tabla></app-ejecutivos-cemento-tabla>
</div>
